import $ from 'jquery'

const object = vnObject
var filters = {}

$('.js-filter').on( 'click', function () {
    $(this).toggleClass( 'filter-active' )

    //$('.js-remove-filters').fadeIn()
    $('.js-remove-filters').css('opacity', '1')

    var tax = $(this).data('tax');
    var id = $(this).data('id');

    if ( $(this).hasClass( 'filter-active' ) ) {
        if (!filters.hasOwnProperty(tax)) {
            filters[tax] = []
        }

        filters[tax].push(id)
    }
    else {
        if (filters.hasOwnProperty(tax)) {
            var index = filters[tax].indexOf(id)
            if (index !== -1) {
                filters[tax].splice(index, 1)
            }
        }
    }

    seachProjects()
} )

$('.js-remove-filters').on('click', function () {
    filters = {}
    //$('.js-remove-filters').fadeOut()
    $('.js-remove-filters').css('opacity', '0')
    $('.filter-active').removeClass('filter-active')

    seachProjects()
})


function seachProjects() {
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            action: 'vn_get_project',
            filters: filters,
        },
        success: function success(res) {
            $('.js-projects-grid').html(res.data.data)
            var projects = $('.js-project')

            projects.on( 'mouseenter', function () {
                $(this).addClass('is-active')
            } )
            projects.on( 'mouseleave', function () {
                $(this).removeClass('is-active')
            } )

            var filterMobileBtn = $('.js-filter-mobile')
            if ( Object.keys(filters).length === 0 ) {
                filterMobileBtn.removeClass('filter-active')
            }
            else {
                filterMobileBtn.addClass('filter-active')
            }
            animateProjectHomeCards()
        }
    });
}


function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

$(document).ready(function() {
    var filtersValue = getParameterByName('filter');

    if (filtersValue) {
        var tax = 'filter';
        var ids = filtersValue.split(',').map(function(item) {
            return parseInt(item.trim()); // Convertit chaque élément en entier
        });

        if (!filters.hasOwnProperty(tax)) {
            filters[tax] = [];
        }

        filters[tax] = filters[tax].concat(ids);

        ids.forEach(function(id) {
            $('[data-id="' + id + '"]').addClass('filter-active');
        });

        var urlWithoutParam = window.location.href.split('?')[0];
        history.replaceState({}, document.title, urlWithoutParam);

        seachProjects();
    }

    var sizesValue = getParameterByName('size');

    if (sizesValue) {
        var tax = 'size';
        var ids = sizesValue.split(',').map(function(item) {
            return parseInt(item.trim()); // Convertit chaque élément en entier
        });

        if (!filters.hasOwnProperty(tax)) {
            filters[tax] = [];
        }

        filters[tax] = filters[tax].concat(ids);

        ids.forEach(function(id) {
            $('[data-id="' + id + '"]').addClass('filter-active');
        });

        var urlWithoutParam = window.location.href.split('?')[0];
        history.replaceState({}, document.title, urlWithoutParam);

        seachProjects();
    }

    var project_typesValue = getParameterByName('project_type');

    if (project_typesValue) {
        var tax = 'project_type';
        var ids = project_typesValue.split(',').map(function(item) {
            return parseInt(item.trim()); // Convertit chaque élément en entier
        });

        if (!filters.hasOwnProperty(tax)) {
            filters[tax] = [];
        }

        filters[tax] = filters[tax].concat(ids);

        ids.forEach(function(id) {
            $('[data-id="' + id + '"]').addClass('filter-active');
        });

        var urlWithoutParam = window.location.href.split('?')[0];
        history.replaceState({}, document.title, urlWithoutParam);

        seachProjects();
    }
})


function animateProjectHomeCards() {
    $(document).ready(function() {
        var elements = $('.feed-home-project');
        var delay = 700;
        elements.each(function(index) {
            var element = $(this);
            setTimeout(function() {
                element.addClass('animate-height');
            }, index * delay);
        });
    });
}
animateProjectHomeCards()
